import Countdown from "../components/Countdown/Countdown"
import { useInvitationParams } from "../components/Params/InvitationParams"
import "./Main.scss"

const openWebsite = (url: string) => {
    window.open(url, '_blank')
}

const isThereInvitee = (invitee?: string) => Boolean(invitee && invitee.trim());

const confirmAssistance = (
    invitee?: string, 
    persons?: number
) => {
    const weddingPhoneNumber = "8188687333" // Add number here
    const message = `¡Hola! ${invitee} confirma la asistencia para ${persons} ${persons === 1 ? 'persona' : 'personas'} a la boda de Arturo y Daniela el 20 de Diciembre del 2025`;
    const whatsappURL = `https://wa.me/${weddingPhoneNumber}?text=${encodeURIComponent(message)}`;

    openWebsite(whatsappURL)
}

export const Main = () => {
    const { invitee, persons } = useInvitationParams();

    return (
        <main>
            <section className="hero">
                <div className="hero__content">
                    <h1 className="header">Arturo</h1>
                    <h1 className="header">&</h1>
                    <h1 className="header">Daniela</h1>
                </div>
            </section>

            <section className="hero-versiculo">
                <div className="hero-versiculo__content">
                    <q className="quote">“Que nuestro amor permanezca en Dios, porque en Él encontramos la fuerza que nos une y nos hace uno solo.”</q>
                    <div className="quote-author">Juan 4:16</div>
                </div>
            </section>

            <section className="hero-countdown">
                <div className="hero-countdown__content">
                    <h1 className="header">Días para nuestro inicio juntos</h1>
                    <Countdown targetDate="2025-12-20T18:00:00" />
                </div>
            </section>

            <section className="hero-letter">
                <img src="./backgrounds/5.svg" alt="" />
            </section>

            <section className="hero-song">
                <div className="hero-song__content">
                    {/* <h1 className="header">Escucha nuestra canción</h1>
                    <iframe
                        src="https://www.youtube.com/embed/wwNaBJJ0qig?autoplay=1&loop=1&controls=1" 
                        title="Canción De Boda Instrumental" 
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen>
                    </iframe> */}
                    {/* <iframe 
                        title="Our song"
                        data-testid="embed-iframe" 
                        src="https://open.spotify.com/embed/track/4y0DMGBN29LArmCvIeDKPZ?utm_source=generator" 
                        height="100"
                        frameBorder="0" 
                        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
                        loading="lazy">
                    </iframe> */}
                </div>
            </section>

            <section className="hero-timeline">
                <div className="event iglesia">
                    <img src="./assets/23.svg" alt="church icon"/>
                    <div className="iglesia__content">
                        <h2>Ceremonia</h2>
                        <h3>Santuario</h3>
                        <h4>6:00 pm</h4>

                        {/* 
                        TODO: Put url in an enum variable
                        */}
                        <button 
                            className="location-button"
                            onClick={() => openWebsite('https://www.google.com/maps/place/Parroquia+Santuario+Pur%C3%ADsima+Concepci%C3%B3n,+Agualeguas/@26.3100738,-99.5394571,17.68z/data=!4m6!3m5!1s0x866397e129dfc605:0x84fc9ac1d6765244!8m2!3d26.3102814!4d-99.5400965!16s%2Fg%2F11fyzd_c8m?entry=ttu&g_ep=EgoyMDI1MTAyNi4wIKXMDSoASAFQAw%3D%3D')}
                        >
                                Ubicación
                        </button>
                    </div>
                </div>
                <div className="event fiesta">
                    <img src="./assets/24.svg" alt="reception icon"/>
                    <div className="fiesta__content">
                        <h2>Recepcion</h2>
                        <h3>Club Femenil Alba</h3>
                        <h4>7:00 pm</h4>

                        <button 
                            className="location-button"
                            onClick={() => openWebsite('https://www.google.com/maps/place/Guerrero+26,+65800+Agualeguas,+N.L./@26.3101565,-99.5393301,19.22z/data=!4m9!1m2!2m1!1sclub+femenil+alba+agualeguas!3m5!1s0x866397e6d9d6a879:0x54cb7ce293b72a7a!8m2!3d26.3103089!4d-99.5388218!16s%2Fg%2F11jyl5qsmm?entry=ttu&g_ep=EgoyMDI1MTAyNi4wIKXMDSoASAFQAw%3D%3D')}
                        >
                                Ubicación
                        </button>
                    </div>
                </div>
            </section>

            <section className="hero-confirmation">
                <div className="hero-confirmation__content">
                    <div className="headline">
                        <div className="header">Confirmación</div>
                        <h3>Nos hace mucha ilusión la posibilidad de poder compartir este día tan especial con ustedes.</h3>
                    </div>

                    <div className="invitee">
                        <h2>{ invitee ?? "No ves tu nombre?" }</h2>
                        <h4>{ persons ? (
                                <>Invitación para {persons}{' '}{persons === 1 ? 'persona' : 'personas'}</>
                            ) : (
                                <>Escribe a Arturo o Dany para poder solucionarlo</>
                            )
                        }</h4>
                    </div>


                    <button 
                        className="button"
                        disabled={!isThereInvitee(invitee)}
                        onClick={() => confirmAssistance(invitee, persons)}
                    >
                        Confirmar
                    </button>
                </div>
            </section>
        </main>
    )
}